import { z } from 'zod';

const paginationCursorSchema = z.string().min(1);

const paginationLimitSchema = z.coerce.number().int().min(1).max(100);

export const paginationQuerySchema = z.object({
  cursor: paginationCursorSchema.optional(),
  limit: paginationLimitSchema.optional(),
});

export const paginationMetaSchema = z.object({
  cursor: z.string().nullable(),
  hasMore: z.boolean(),
});

export type PaginationQuery = z.infer<typeof paginationQuerySchema>;
export type PaginationMeta = z.infer<typeof paginationMetaSchema>;
export type WithPagination<T> = {
  data: T[];
  pagination: PaginationMeta;
};
